import { Injectable, Inject } from '@angular/core';
import { AppSettings } from '../../configs/app-settings.config';

@Injectable()
export class TranslateService {
    constructor(private appSettings:AppSettings) {
        // Code to get Locale Info from Session Storage
    }

    getDateString(datenum:number):string{
        return new Date(datenum).toLocaleDateString(this.appSettings.defaultLocale, this.appSettings.dateFormat);
    }

    getCurrencyString(number:number):string {
        return number.toLocaleString(this.appSettings.defaultLocale, this.appSettings.currencyFormat);
    }


}
